module.exports = __webpack_public_path__ + "img/icon-account-guest.1c4c72ef.svg";